import React, { FC } from 'react'

import DefaultLayout, { DefaultLayoutProps } from '../../layouts/DefaultLayout'
import { BackLinkProps } from '../../components/BackLink'
import { ConfirmationFormProps } from '../../components/forms/ConfirmationForm'
import { AuthenticationIntroProps } from '../../components/AuthenticationIntro'

import * as SC from './styled'

export type ConfirmationTemplateProps = {
  className?: string
  layout?: DefaultLayoutProps
  backLink?: BackLinkProps
  intro?: AuthenticationIntroProps
  form?: ConfirmationFormProps
}

const ConfirmationTemplate: FC<ConfirmationTemplateProps> = (props) => {
  const { layout, backLink, form, intro } = props

  return (
    <DefaultLayout {...layout}>
      <SC.Content>
        <SC.ContentBoxC>
          {backLink && <SC.Back {...backLink} />}
          {intro && <SC.Intro {...intro} />}
          {form && <SC.Form {...form} />}
        </SC.ContentBoxC>
      </SC.Content>
    </DefaultLayout>
  )
}

export default ConfirmationTemplate
